module.exports = __webpack_public_path__ + "img/receipt32.b37f25e9.svg";